module.exports = __webpack_public_path__ + "img/1.bf59de8d.png";